/**
 * Content Container Component
 * @module patterns/components/containers/content-container
 */

import { App } from '~/app';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Content Container Component');

    const listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]> = [];

    app.afterMount
        .then(() => {
            mountContentContainer(listeners);
        })
        .catch((error) => {
            throw new Error('[Stockland FE] Unable to register Stockland Content Container component', error);
        });

    return function destroyContentContainer() {
        unMountContentContainer(listeners);

        app.logger.debug('[DXA] Content Container component destroyed');
    };
};

// Extracted method for logic reuse within other component
export function mountContentContainer(
    listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>,
    root: HTMLElement | null = null
) {
    let rootNode: Document | HTMLElement = document;
    if (root) rootNode = root;

    const contentContainers = rootNode.querySelectorAll<HTMLElement>('.content-container-component');

    for (const contentContainer of contentContainers) {
        const stickyCol2 = contentContainer.querySelector<HTMLElement>('.sticky-col2');

        // Check if the content container is within a Floating Island and update column 2 top position accordinginly
        if (stickyCol2?.closest('.floating-island') && stickyCol2?.classList.contains('md:top-24')) {
            stickyCol2.classList.remove('md:top-24');
            stickyCol2.classList.add('md:top-48');
        }
    }
}

export function unMountContentContainer(
    listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>
) {
    for (const [element, event, listener] of listeners) {
        element.removeEventListener(event, listener);
    }
}
